import { isEmptyValue } from './value-utils';

//Normaliza un string eliminando acentos y caracteres especiales
export const normalizeString = (str: string): string => {
	if (!str) return '';

	return str
		.normalize('NFD') // Normaliza los caracteres acentuados
		.replace(/[\u0300-\u036f]/g, '') // Elimina los acentos
		.replace(/[^a-zA-Z0-9\s]/g, '') // Elimina caracteres especiales
		.trim(); // Elimina espacios al inicio y al final
};

// Añade un digito si es necesario
export const numberToTwoChars = (str: string): string => {
	if (isEmptyValue(str)) {
		return '';
	}

	str = String(str);

	return str.length === 1 ? '0' + str : str;
};

// Capitaliza la primera letra de un string
export const strCapitalize = (text: string): string => {
	if (typeof text !== 'string' || !text) {
		return '';
	}
	return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

// Capitaliza la primera letra de cada palabra en un string
export const strTitlelize = (str: string): string => {
	if (!str) return '';
	return str
		.toLowerCase()
		.split(' ') // separar palabras para capitalizar
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ')
		.split('.') // separar sociedades para capitalizar (S.A., S.L.U.)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join('.');
};

// Elimina las etiquetas <p> y </p> de un string HTML
export const removeParagraphTags = (htmlString: string): string => {
	const regex = /<\/?p[^>]*>/g;
	return htmlString?.replace(regex, '');
};

// Convierte el texto subrayado en negrita para Markdown
export function underlineToMarkdownBold(text: string): string {
	return text
		.replace(/^\*/, '')
		.replace(/<u>/g, '**')
		.replace(/<\/u>/g, '**')
		.replace(/<\/?[^>]+(>|$)/g, '');
}

// Para los casos como "Rioja, La" convierte en "La Rioja"
export const normalizeProvince = (str: string): string => {
	if (!str) return '';

	let cleanStr = str.trim();

	if (cleanStr.includes(',')) {
		const parts = cleanStr.split(',').map((p) => p.trim());
		cleanStr = parts.reverse().join(' ');
	}

	return cleanStr;
};

// Para convertir "my-renting" en "My Renting"
export const formatSlugToTitle = (text?: string | null): string => {
	if (!text) return '';

	return text
		.replace(/[-_]+/g, ' ')
		.trim()
		.split(/\s+/)
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(' ');
};

// Para evitar "Nuevo Nuevo" o "Oferta Oferta" en textos
export const removeConsecutiveDuplicates = (text: string): string => {
	if (!text) return '';
	return text.replace(/\b([\w-]+)(?:\s+\1\b)+/gi, '$1');
};

export const removeExtraSpaces = (text: string): string => {
	if (!text) return '';
	return text.replace(/\s{2,}/g, ' ').trim();
};

export const normalizeHyphens = (text?: string): string => {
	if (!text) return '';
	return text.replace(/-/g, '‑');
};
